import { useEffect } from 'react'
import { useSoundContext } from '../contexts/SoundContext'
import { useToast } from '../hooks/useToast'

/**
 * SoundToastBridge
 *
 * Connects the Sound system to the Toast system so that
 * toasts can optionally play sounds when they appear.
 *
 * Place this component inside both providers to bridge them.
 */
export default function SoundToastBridge() {
  const { play } = useSoundContext()
  const { setSoundPlayer } = useToast()

  useEffect(() => {
    if (setSoundPlayer && play) {
      setSoundPlayer(play)
    }
  }, [setSoundPlayer, play])

  return null
}
